import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { jsx } from 'react/jsx-runtime';

// src/listen/minimalism/home/feeling-list/skeleton.tsx
var FeelingListSkeleton = () => {
  return /* @__PURE__ */ jsx(Box, { display: "flex", gap: 1.5, my: 2, role: "status", "aria-label": "Loading feelings list", children: [1, 2, 3, 4, 5].map((item) => /* @__PURE__ */ jsx(Skeleton, { variant: "rounded", width: 66, height: 32 }, item)) });
};

export { FeelingListSkeleton };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-S5E7VNPE.mjs.map